import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTransactionListingComponent } from '../new-transaction-listing/new-transaction-listing.component';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { GoogleReviewModalComponent } from '../google-review-modal/google-review-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-new-sub-admins-rental-auth',
  templateUrl: './new-sub-admins.component.html',
  styleUrls: ['./new-sub-admins.component.scss'],
})
export class NewSubAdminsUsersAuth implements OnInit {
  @ViewChild('UploadFileModal') uploadFileModal: TemplateRef<any>;
  transactions: any;
  passCode: any;
  total_txn: number = 0;
  tab_type = 3;
  userDropdown: { name: string; }[];
  slotTransactions: any;
  cashbackValue: any;
  user_of: any;
  
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private modalService: NgbModal,
    private local: LocalServiceService
  ) {}

  ngOnInit(): void { 
    this.vip_sub_transactions(); 
  }
    
  vip_sub_transactions() {
    let  show = '6';
    this.auth.vip_transactions(show).subscribe((response: any) => {
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }
  openModal(content: any) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });


   // this.cashbackId = null;
    //this.cashbackValue = 0;
   // this.termsAndConditions = '';
  }
  collectAmount(user_id) {
    this.user_of = user_id;
    this.passCode = '';
    this.cashbackValue = '';
    this.openModal(this.uploadFileModal); 
  }
  isUploading: boolean = false
  handleUpload() {
    if (this.passCode == null || this.passCode < 1) {
      this.toastr.warning("Passcode is required");
      return;
    }
    if (this.cashbackValue == null || this.cashbackValue < 1) {
      this.toastr.warning("Amount is less");
      return;
    }

    this.isUploading = true;

    const payload = new FormData();

    payload.append('amount', this.cashbackValue);
    payload.append('user_id', this.cashbackValue);
    payload.append('passcode', this.passCode);
    payload.append('show', '6');
      let show = '6';
      this.auth.vip_transactions(show, this.cashbackValue, this.user_of, this.passCode).subscribe((response: any) => {

      //window.location.reload(); 
      this.toastr.success('Successfully Charged...');
      this.modalService.dismissAll();
      this.isUploading = false;
      this.transactions = response.body.transactions;
      this.total_txn = response.body.available;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      } else if (error.status == 400) {
        this.toastr.warning(error.error?.message || 'Charge failed...'); 
        this.modalService.dismissAll(); 
        this.isUploading = false;
      }
    });



  }
   
}
